<template>
  <div class="nav-bar" v-if="!$store.getters.isPC">
    <van-nav-bar
      fixed
      :title="title"
      left-text
      left-arrow
      @click-left="onClickLeft"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isYiban: false
    }
  },
  mounted () {
    try {
      if (localStorage.getItem('isForm') == 1) {
        this.isYiban = true
      }
    } catch (error) {}
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/css/mixin';
.nav-bar {
  height: 48px;
}
.yi-Ban {
  ::v-deep .van-nav-bar--fixed {
    top: 0;
  }
}
.van-nav-bar .van-icon {
  color: $gray;
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue